import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { betStore } from '@pascal/pascal-core/shared/core/store';

import { BetSection } from './betSection';
import { BetTypes, RoundStepInfoSection } from '../common';
import { MobileBetSectionWrapper } from '../mobile/mobileBetSectionWrapper';

export const BetBlock = observer(
  ({
    t,
    odd,
    isOpen,
    isDemo,
    limits,
    betTypes,
    isMobile,
    betAmount,
    reBetData,
    handleSubmit,
    currencyCode,
    activeButton,
    setBetAmount,
    setNumPadData,
    activeFreeBet,
    handleClickBet,
    handleInputBlur,
    totalBetsAmount,
    betPendingToggle,
    reBetPendingToggle,
    numPudInputValue,
    handleOpenNumPad,
    betTypesActiveBets,
    partnerWageringOdd,
    handleChangeBetType,
    updateNumPudInputValue,
    handleChangeInputValue,
  }) => {
    const [isValidatedAmount, setIsValidatedAmount] = useState(false);
    const { repliedBetData } = betStore;
    const decidedCallBackCall = (callback) => {
      if (isValidatedAmount) {
        setIsValidatedAmount(false);
      } else {
        // soundService.play(soundTypes.clickButton);
        return callback();
      }
      return null;
    };
    useEffect(() => {
      if (activeFreeBet.id) {
        setBetAmount(activeFreeBet?.amount);
      } else {
        setBetAmount(
          repliedBetData ? repliedBetData.amount : limits.defaultBetAmount || limits.minBet
        );
      }
    }, [activeFreeBet, limits, setBetAmount, repliedBetData]);

    return (
      <>
        <RoundStepInfoSection isMobile={isMobile} />
        <BetTypes
          odd={odd}
          betTypes={betTypes}
          isMobile={isMobile}
          betTypesActiveBets={betTypesActiveBets}
          handleChangeBetType={handleChangeBetType}
        />
        {isMobile ? (
          <MobileBetSectionWrapper
            t={t}
            odd={odd}
            isOpen={isOpen}
            isDemo={isDemo}
            limits={limits}
            reBetData={reBetData}
            betAmount={betAmount}
            activeButton={activeButton}
            setBetAmount={setBetAmount}
            handleSubmit={handleSubmit}
            setNumPadData={setNumPadData}
            activeFreeBet={activeFreeBet}
            handleClickBet={handleClickBet}
            totalBetsAmount={totalBetsAmount}
            handleInputBlur={handleInputBlur}
            numPudInputValue={numPudInputValue}
            handleOpenNumPad={handleOpenNumPad}
            betPendingToggle={betPendingToggle}
            reBetPendingToggle={reBetPendingToggle}
            partnerWageringOdd={partnerWageringOdd}
            decidedCallBackCall={decidedCallBackCall}
            setIsValidatedAmount={setIsValidatedAmount}
            updateNumPudInputValue={updateNumPudInputValue}
            handleChangeInputValue={handleChangeInputValue}
          />
        ) : (
          <BetSection
            t={t}
            odd={odd}
            isDemo={isDemo}
            limits={limits}
            reBetData={reBetData}
            betAmount={betAmount}
            currencyCode={currencyCode}
            activeButton={activeButton}
            setBetAmount={setBetAmount}
            activeFreeBet={activeFreeBet}
            handleClickBet={handleClickBet}
            handleInputBlur={handleInputBlur}
            totalBetsAmount={totalBetsAmount}
            betPendingToggle={betPendingToggle}
            reBetPendingToggle={reBetPendingToggle}
            partnerWageringOdd={partnerWageringOdd}
            decidedCallBackCall={decidedCallBackCall}
            setIsValidatedAmount={setIsValidatedAmount}
            handleChangeInputValue={handleChangeInputValue}
          />
        )}
      </>
    );
  }
);
